import { LoadTrailers } from "../../hooks/react-query/outbound/linehaulTrailers/useLoadTrailers";

export const loadTrailersResponse = {
  empty: {
    total: {
      summary: {
        bills: 0,
        pallets: 0,
        pieces: 0,
        weight: 0,
        trailers: 0,
        trips: 0,
        traps: 0,
        hidden: 0,
      },
    },
    trips: {
      trailers: [],
      summary: { bills: 0, pieces: 0, pallets: 0, weight: 0, trailers: 0 },
    },
    traps: {
      trailers: [],
      summary: { bills: 0, pieces: 0, pallets: 0, weight: 0, trailers: 0 },
    },
    hidden: {
      trailers: [],
      summary: { bills: 0, pieces: 0, pallets: 0, weight: 0, trailers: 0 },
    },
  },
  default: {
    trips: {
      trailers: [
        {
          plannedPullId: 53029,
          doorNumber: 20,
          tripNumber: 3087048,
          carrier: "ORANGE TRANSPORTATION LLC",
          stopSic: "",
          stopSicId: null,
          trailerNumber: "DALGHOST25",
          status: "LDDK",
          shipmentTags: [],
          bookingNumber: "ATHER/TAHIR",
          originSic: "DAL",
          destinationSic: "PER-DHRN",
          laneType: "Regular",
          ectDateTime: new Date("2025-01-01T17:29:00"),
          isActDelayed: false,
          actDateTime: null,
          departureDateTime: null,
          bills: 1,
          pieces: 1,
          pallets: 0,
          weight: 260,
          serviceDue: new Date("2025-06-01T19:00:00"),
          sealNumber: "",
          cube: 30,
          isLoadAndHold: true,
          trailerType: 1,
          trailerTypeName: "Linehaul",
          trapName: "",
          containsNotes: true,
          isFromPreviousPlan: true,
          isHidden: false,
          isExcluded: false,
        },
        {
          plannedPullId: 53035,
          doorNumber: 22,
          tripNumber: 3087175,
          carrier: "MIDWEST BEST CARRIERS INC.",
          stopSic: "",
          stopSicId: null,
          trailerNumber: "530-1112",
          status: "CLOS",
          shipmentTags: [],
          bookingNumber: "MAURITA/KEVIN - WEATHER",
          originSic: "DAL",
          destinationSic: "MDW-CXIT",
          laneType: "Regular",
          ectDateTime: new Date("2025-01-01T17:29:00"),
          isActDelayed: false,
          actDateTime: new Date("2025-01-01T17:29:00"),
          departureDateTime: new Date("2025-01-01T17:29:00"),
          bills: 0,
          pieces: 0,
          pallets: 0,
          weight: 0,
          serviceDue: null,
          sealNumber: "",
          cube: 0,
          isLoadAndHold: false,
          trailerType: 1,
          trailerTypeName: "Linehaul",
          trapName: "",
          containsNotes: false,
          isFromPreviousPlan: false,
          isHidden: false,
          isExcluded: false,
        },
        {
          plannedPullId: 53024,
          doorNumber: 78,
          tripNumber: 3071255,
          carrier: "OMNI GALAXY TRANSPORTATION INC",
          stopSic: "",
          stopSicId: null,
          trailerNumber: "530-1052",
          status: "LDDK",
          shipmentTags: [
            {
              id: 4,
              name: "APTR",
              color: "#777DE9",
              description: "Appointment Required ",
            },
            {
              id: 81,
              name: "VC",
              color: "#AA7EA0",
              description: "Vendor Compliance",
            },
            {
              id: 8,
              name: "LM",
              color: "#E280B4",
              description:
                "Large Mark - 6 plts or greater-6,000 lbs or greater",
            },
          ],
          bookingNumber: "DAVID WHITE/SHUPENG LIU\u00A0",
          originSic: "DAL",
          destinationSic: "EWR",
          laneType: "Regular",
          ectDateTime: new Date("2025-01-01T19:30:00"),
          isActDelayed: false,
          actDateTime: null,
          departureDateTime: null,
          bills: 16,
          pieces: 367,
          pallets: 42,
          weight: 41774,
          serviceDue: new Date("2025-06-29T20:00:00"),
          sealNumber: "",
          cube: 0,
          isLoadAndHold: false,
          trailerType: 1,
          trailerTypeName: "Linehaul",
          trapName: "",
          containsNotes: true,
          isFromPreviousPlan: true,
          isHidden: false,
          isExcluded: false,
        },
        {
          plannedPullId: 53033,
          doorNumber: 79,
          tripNumber: 3090222,
          carrier: "COVENANT TRANSPORT INC",
          stopSic: "",
          stopSicId: null,
          trailerNumber: "DAL017",
          status: "LDDK",
          shipmentTags: [],
          bookingNumber: "TEAM I",
          originSic: "DAL",
          destinationSic: "EWR",
          laneType: "Regular",
          ectDateTime: new Date("2025-01-01T14:30:00"),
          isActDelayed: false,
          actDateTime: null,
          departureDateTime: null,
          bills: 1,
          pieces: 0,
          pallets: 0,
          weight: 0,
          serviceDue: null,
          sealNumber: "",
          cube: 0,
          isLoadAndHold: false,
          trailerType: 1,
          trailerTypeName: "Linehaul",
          trapName: "",
          containsNotes: true,
          isFromPreviousPlan: false,
          isHidden: false,
          isExcluded: false,
        },
        {
          plannedPullId: 53034,
          doorNumber: 78,
          tripNumber: 3090999,
          carrier: "COVENANT TRANSPORT INC",
          stopSic: "",
          stopSicId: null,
          trailerNumber: "DAL018",
          status: "PLAN",
          shipmentTags: [],
          bookingNumber: "TEAM E",
          originSic: "DAL",
          destinationSic: "EWR",
          laneType: "Regular",
          ectDateTime: new Date("2025-01-01T14:35:00"),
          isActDelayed: false,
          actDateTime: null,
          departureDateTime: null,
          bills: 1,
          pieces: 0,
          pallets: 0,
          weight: 0,
          serviceDue: null,
          sealNumber: "",
          cube: 0,
          isLoadAndHold: false,
          trailerType: 1,
          trailerTypeName: "Linehaul",
          trapName: "",
          containsNotes: true,
          isFromPreviousPlan: false,
          isHidden: false,
          isExcluded: false,
        },
        {
          plannedPullId: 53028,
          doorNumber: 86,
          tripNumber: 3087047,
          carrier: "MARSA TRANSPORTATION INC",
          stopSic: "",
          stopSicId: null,
          trailerNumber: "OB TRAP 7",
          status: "LDDK",
          shipmentTags: [
            {
              id: 4,
              name: "APTR",
              color: "#777DE9",
              description: "Appointment Required ",
            },
          ],
          bookingNumber: "MARLON/LINN",
          originSic: "DAL",
          destinationSic: "LAX",
          laneType: "Regular",
          ectDateTime: new Date("2025-01-01T10:30:00"),
          isActDelayed: false,
          actDateTime: null,
          departureDateTime: null,
          bills: 0,
          pieces: 0,
          pallets: 0,
          weight: 0,
          serviceDue: new Date("2022-05-01T17:00:00"),
          sealNumber: "",
          cube: 0,
          isLoadAndHold: false,
          trailerType: 1,
          trailerTypeName: "Linehaul",
          trapName: "",
          containsNotes: false,
          isFromPreviousPlan: true,
          isHidden: false,
          isExcluded: false,
        },
      ],
      summary: {
        bills: 19,
        pieces: 369,
        pallets: 44,
        weight: 42484,
        trailers: 5,
      },
    },
    traps: {
      trailers: [
        {
          plannedPullId: 53039,
          doorNumber: 4,
          tripNumber: null,
          carrier: "",
          stopSic: "",
          stopSicId: null,
          trailerNumber: "DALGHOST11",
          status: "TPLN",
          shipmentTags: [],
          bookingNumber: "",
          originSic: "DAL",
          destinationSic: "DAL",
          laneType: "Regular",
          ectDateTime: null,
          isActDelayed: false,
          actDateTime: null,
          departureDateTime: null,
          bills: 0,
          pieces: 0,
          pallets: 0,
          weight: 0,
          serviceDue: null,
          sealNumber: "",
          cube: 0,
          isLoadAndHold: false,
          trailerType: 2,
          trailerTypeName: "Trap",
          trapName: "TRAP NEW",
          containsNotes: false,
          isFromPreviousPlan: false,
          isHidden: false,
          isExcluded: false,
        },
        {
          plannedPullId: 53031,
          doorNumber: 39,
          tripNumber: null,
          carrier: "",
          stopSic: "",
          stopSicId: null,
          trailerNumber: "DALGHOST23",
          status: "LDDK",
          shipmentTags: [
            {
              id: 4,
              name: "APTR",
              color: "#777DE9",
              description: "Appointment Required ",
            },
            {
              id: 81,
              name: "VC",
              color: "#AA7EA0",
              description: "Vendor Compliance",
            },
          ],
          bookingNumber: "",
          originSic: "DAL",
          destinationSic: "DAL",
          laneType: "Regular",
          ectDateTime: null,
          isActDelayed: false,
          actDateTime: null,
          departureDateTime: null,
          bills: 3,
          pieces: 78,
          pallets: 3,
          weight: 2559,
          serviceDue: new Date("2025-06-30T19:00:00"),
          sealNumber: "",
          cube: 0,
          isLoadAndHold: false,
          trailerType: 2,
          trailerTypeName: "Trap",
          trapName: "TRAP 2",
          containsNotes: false,
          isFromPreviousPlan: true,
          isHidden: false,
          isExcluded: false,
        },
      ],
      summary: {
        bills: 6,
        pieces: 80,
        pallets: 6,
        weight: 8172,
        trailers: 2,
      },
    },
    hidden: {
      trailers: [
        {
          plannedPullId: 53034,
          doorNumber: 10,
          tripNumber: 3085370,
          carrier: "MURILLO LOGISTIC INC",
          stopSic: "",
          stopSicId: null,
          trailerNumber: "480-4025",
          status: "CLOS",
          shipmentTags: [],
          bookingNumber: "ISRAEL - FRI",
          originSic: "DAL",
          destinationSic: "HTX",
          laneType: "Regular",
          ectDateTime: new Date("2025-01-01T16:00:00"),
          isActDelayed: false,
          actDateTime: null,
          departureDateTime: null,
          bills: 0,
          pieces: 0,
          pallets: 0,
          weight: 0,
          serviceDue: null,
          sealNumber: "",
          cube: 0,
          isLoadAndHold: false,
          trailerType: 1,
          trailerTypeName: "Linehaul",
          trapName: "",
          containsNotes: false,
          isFromPreviousPlan: false,
          isHidden: true,
          isExcluded: true,
        },
        {
          plannedPullId: 53040,
          doorNumber: 33,
          tripNumber: null,
          carrier: "",
          stopSic: "",
          stopSicId: null,
          trailerNumber: "DALGHOST15",
          status: "LDDK",
          shipmentTags: [
            {
              id: 4,
              name: "APTR",
              color: "#777DE9",
              description: "Appointment Required ",
            },
            {
              id: 75,
              name: "OVL",
              color: "#C77563",
              description: "Overlength",
            },
          ],
          bookingNumber: "",
          originSic: "DAL",
          destinationSic: "DAL",
          laneType: "Regular",
          ectDateTime: null,
          isActDelayed: false,
          actDateTime: null,
          departureDateTime: null,
          bills: 3,
          pieces: 2,
          pallets: 3,
          weight: 5613,
          serviceDue: new Date("2025-06-29T20:00:00"),
          sealNumber: "",
          cube: 0,
          isLoadAndHold: false,
          trailerType: 2,
          trailerTypeName: "Trap",
          trapName: "NEW TRAP",
          containsNotes: false,
          isFromPreviousPlan: false,
          isHidden: true,
          isExcluded: true,
        },
      ],
      summary: {
        bills: 3,
        pieces: 2,
        pallets: 3,
        weight: 5613,
        trailers: 2,
      },
    },
    total: {
      summary: {
        bills: 27,
        pieces: 451,
        pallets: 56,
        weight: 53019,
        trailers: 9,
        traps: 2,
        trips: 5,
        hidden: 2,
      },
    },
  },
} as const satisfies Record<string, LoadTrailers>;
